import Badge from "./Badge";
import BadgeContainer from "./BadgeContainer";
import BadgeRadiocorner from "./BadgeRadiocorner";
import BadgeSelectcolor from "./BadgeSelectcolor";
import BadgeFooter from "./BadgeFooter";

Badge.Container = BadgeContainer
Badge.RadioCorner = BadgeRadiocorner
Badge.SelectColor = BadgeSelectcolor
Badge.Footer = BadgeFooter

export default Badge